export default __webpack_public_path__ + "static/media/gallery_01.f8ccd85a.jpg";